import type { DOMOutputSpec, Node, Node as ProsemirrorNode, NodeSpec } from 'prosemirror-model';

import { NodeName } from '../../schema/nodes';

export class LinkNode implements NodeSpec {
  public static readonly nodeName = NodeName.Link;
  public static is(node: ProsemirrorNode) {
    return node.type.name === LinkNode.nodeName;
  }
  public attrs = {
    id: {},
    label: {},
    href: {},
    name: {},
  };
  public inline = true;
  public atom = true;
  public content = 'inline+';
  public group = 'inline';
  public selectable = false;
  public draggable = false;
  public defining = true;
  public parseDOM = [
    {
      tag: 'span[data-component-type="prosemirror-link-item"]',
      getAttrs: (node: HTMLElement) => node.dataset,
    },
  ];

  public toDOM = (node: Node): DOMOutputSpec => [
    'span',
    {
      'data-id': node.attrs['id'],
      'data-label': node.attrs['label'],
      'data-name': node.attrs['name'],
      'data-href': node.attrs['href'],
      'data-component-type': 'prosemirror-link-item',
    },
    node.attrs['href'],
  ];
}
